import styled from 'styled-components';

export const FloaterStyled = styled.section<{ isVisible: boolean }>`
  width: 100%;
  overflow: hidden;
  position: fixed;
  bottom: 0;
  z-index: 11;
  transition: transform 250ms ease-out;
  transform: translateY(${({ isVisible }) => (isVisible ? '0%' : '100%')});
  background-color: #333;
  // padding: 5px;

  .floating-cta__header {
    background-color: #333333;
    color: #fff;

    &__wrapper {
      max-width: 1132px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      gap: 8px;
      align-self: stretch;
      font-size: 12px;
      font-weight: bold;
      line-height: 16px;
    }

    &__number {
      display: flex;
      height: 28px;
      padding: 9px 28px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      background-color: #00A871;
    }

    &__text {
      display: flex;
      height: 24px;
      align-items: center;
      gap: 4px;

      &__divider {
        flex: 1;
        width: 1px;
        height: 16px;
        background: #fff;
      }
    }
  }

  .floating-cta__body {
    max-width: 1132px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    position: relative;
    background-color: #fff;
  }

  .floating-cta__content {
    display: flex;
    padding: 8px;
    align-items: center;
    align-self: stretch;
    color: black;
    gap: 8px; 

    &Image {
      border-radius: 6px;
      grid-row: 1/3;
      grid-column: 1/2;
      height: 48px;
      width: 48px;
      margin-right: 8px;
    }

    &Divider {
      width: 1px;
      height: 40px;
      flex-shrink: 0;
      background: #DCDCDC;
    }

    &Text {
      font-size: 12px;
      line-height: 16px;

      &Rating {
        display: flex;
        align-items: center;
        gap: 4px;
        font-weight: 700;
      }
    }
  }

  .floating-cta__button {
    display: flex;
    width: 135px;
    height: auto;
    min-height: 44px;
    min-width: 135px;
    padding: 14px 8px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    margin-left: auto;
    line-height: 16px;
    border-radius: 17px;

    svg {
      width: 8px;
      height: 12px;
    }
  }
`;